module.exports = __webpack_public_path__ + "static/img/subsidy-icon.903f5431.png";